import { NodeId, NodeModel, NodeType } from './node.model';

type MakeNodeArgs = {
  id: NodeId;
  type: NodeType;
  parentId?: NodeId;
  extent?: 'parent';
  x: number;
  y: number;
  data: NodeModel['data'];
  width?: number;
  height?: number;
};

export const makeNode = (args: MakeNodeArgs): NodeModel => {
  const { id, type, parentId, extent, x, y, data, width, height } = args;

  return {
    id,
    type,
    ...(parentId && { parentId }),
    ...(extent && { extent }),
    position: { x, y },
    ...(type === 'swimlane' && {
      zIndex: -1,
      draggable: false,
      expandParent: true,
    }),
    ...(type === 'swimlaneGroup' && { zIndex: -1 }),
    data,
    measured: {
      width: width,
      height: height,
    },
    width: width,
    height: height,
  } as NodeModel;
};
